<style scoped>

</style>
<template>
  <div />
</template>
<script>
  import Consumer from './libs/consumer';
  import { ASYNC_DATA, CALC_DATA } from '../../vuex/async_data';
  const loaded_data = {}; // 存取真实值
  const MODULE_NAME = 'async';
  export default {
    data() {
      return {
        connected: false,
        updating_hash: {}
      }
    },
    computed: {
      //
    },
    created() {
      this.init();
      this.registerModule();
      this.addEventsListener();
    },
    beforeDestroy() {
      this.offEventsListener();
    },
    methods: {
      init() {
        // 连接websocket
        this.channel = Consumer.subscriptions.create({channel: 'AsyncDataChannel'}, {
          received: (data) => {
            const keys = Object.keys(data);
            keys.forEach(key => {
              this.updating_hash[key] = false;
              const mutation_key = `${MODULE_NAME}/${this.mutationKey(key)}`;
              const value = data[key];
              loaded_data[key] = value;
              // 接收到数据后调用相应的方法
              this.$store.commit(mutation_key, value);
            })
          },
          connected: () => {
            console.log('AsyncDataChannel connected');
            this.connected = true;
            // 断线重连后，获取失败的数据
            this.loadFailedData();
          }
        });
      },
      registerModule() {
        if (!this.$store.hasModule(MODULE_NAME)) {
          const config = this.getModuleConfig();
          config.getters = Object.assign(config.getters, CALC_DATA);
        
          this.$store.registerModule(MODULE_NAME, config);
        }
      },
      addEventsListener() {
        eventHub.$on('async-data-update', this.updateValue);
      },
      offEventsListener() {
        eventHub.$off('async-data-update', this.updateValue);
      },
      mutationKey(key) {
        return `update_${key}`;
      },
      updateValue(key, try_count = 0) {
        if (this.updating_hash[key] || try_count >= 10) {
          return;
        }
        // console.log('Try update async data:', key, try_count);
        if (this.connected) {
          this.updating_hash[key] = true;
          this.channel.send({key});
        } else {
          setTimeout(() => {
            this.updateValue(key, try_count + 1);
          }, 1000);
        }
      },
      loadFailedData() {
        // 获取 updating_hash 中 key = true 的 keys
        const failed_keys = Object.keys(this.updating_hash).filter(key => this.updating_hash[key])
        failed_keys.forEach((key) => {
          this.updating_hash[key] = false;
          this.updateValue(key);
        });
      },
      /*
        构造
      */
      getModuleConfig() {
        const module = {
          namespaced: true,
          mutations: {},
          getters: {}
        };
        const module_state_hash = {};
        Object.keys(ASYNC_DATA).forEach((key) => {
          // states
          const state_key = `${key}_default`;
          module_state_hash[state_key] = ASYNC_DATA[key]['default'];
          // mutations
          const mutation_key = this.mutationKey(key);
          module['mutations'][mutation_key] = (state, payload) => {
            state[state_key] = payload;
          };
          // getters
          /*
            getters获取到值取值，
            没有值再请求
            这里的getter主要是数组列表的值
          */
          module['getters'][key] = (state) => {
            const default_value = state[state_key];
            const real_value = loaded_data[key];
            if (real_value) {
              return real_value;
            } else {
              this.updateValue(key);
            }
            return default_value;
          }
        });
        module.state = () => module_state_hash;
        return module;
      }
    }
  }
</script>
